import React from 'react';
import { __UNSAFE_SPACE_TO_DIMSUM, styled } from '@elliemae/ds-system';

const StyledInput = styled.input`
  input[type='time']& {
    -webkit-appearance: none;
    -moz-appearance: none;
    -webkit-tap-highlight-color: transparent;
    appearance: none;
    color: transparent;

    white-space: nowrap;
    position: relative;
    height: ${(props) => __UNSAFE_SPACE_TO_DIMSUM(props.theme.space.l)};
    width: 100%;
    max-width: calc(100% - 32px);
    outline: none;
    box-sizing: border-box;
    display: flex;
    background: ${(props) => props.theme.colors.neutral['000']};
    padding: 0 ${(props) => __UNSAFE_SPACE_TO_DIMSUM(props.theme.space.xs)};
    z-index: 1;
    border-radius: 2px;
    border: solid 1px ${(props) => props.theme.colors.neutral[200]};
  }

  input[type='time']&:active,
  input[type='time']&:focus {
    outline: none;
    border: 1px solid ${({ theme }) => theme.colors.brand[700]};
    border-radius: 2px;
  }

  &:before {
    color: ${(props) => (props.value === '' ? props.theme.colors.neutral['500'] : props.theme.colors.neutral['800'])};
    content: '${(props) => (props.value === '' ? props.placeholder : props['data-displayvalue'])}';
  }

  input[type='time']&::-webkit-datetime-edit,
  input[type='time']&::-webkit-inner-spin-button,
  input[type='time']&::-webkit-clear-button {
    -webkit-appearance: none;
    display: none;
  }
`;

export const Input = ({ innerRef, ...props }) => <StyledInput innerRef={innerRef} {...props} />;
